import React, { Fragment } from 'react';
import OfferEntryPrivate from './private';
import OfferEntryBusiness from './business';
import ListModel from '../../state/ListModel';
import OfferModel from '../../state/OfferModel';
import EliteModel from '../../state/EliteModel';
import IntroText from '../../components/IntroText';
import EliteServiceOffer from '../../components/EliteServiceOffer';
import { getBackground, startsReversed } from 'Utils/getColor';
import TableOfContents from './tableOfContents';

export const getOfferComponentMap = (offer) => ({
  SERVICE: EliteServiceOffer,
  PRIVATE: OfferEntryPrivate,
  BUSINESS: OfferEntryBusiness,
  SPECIAL: OfferEntryPrivate,
});

const getModel = (offerType) => (offerType === 'SERVICE' ? EliteModel : OfferModel);

export default class OfferList extends React.Component {
  // we avoid over engineering by using the vanilla way
  onScrollToOffer = (index) => {
    const offer = document.querySelector(`#offer-${index}`);
    if (!offer) {
      return;
    }

    offer.scrollIntoView({ behavior: 'smooth' });
  };

  isPriceUnset = (price) => !price || +(price || '') === 0;

  render() {
    const { offerList, background } = this.props;
    const offerType = !!offerList[0] ? offerList[0].offerType : '';

    const offerListModel = new ListModel(offerList, getModel(offerType));
    offerListModel.moveItemCategory('LureOffer', 'end');

    if (offerListModel.items.length === 0) {
      return <IntroText background={background} title="Zurzeit sind keine Angebote vorhanden" />;
    }

    return (
      <Fragment>
        {offerType === 'SERVICE' && (
          <TableOfContents
            // it will take the prev background like this
            background={getBackground(1, startsReversed(background))}
            offerListModel={offerListModel}
            onSelect={this.onScrollToOffer}
          />
        )}

        {offerListModel.items.reduce((acc, offer) => {
          const { cashPrice, leasingPrice, financePrice, price, offerType, id } = offer;

          // special offers are already filtered in the backend, but other offer types are still filtered here in the frontend
          if (
            // we only filter non-service stuff which has no table of contents
            offerType !== 'SERVICE' &&
            this.isPriceUnset(cashPrice && cashPrice.price) &&
            this.isPriceUnset(leasingPrice && leasingPrice.price) &&
            this.isPriceUnset(financePrice && financePrice.price) &&
            this.isPriceUnset(price)
          ) {
            return acc;
          }

          const OfferComponent = getOfferComponentMap(offer)[offerType];
          const index = acc.length;

          acc.push(
            <OfferComponent
              {...this.props}
              key={id}
              offer={offer}
              index={index}
              // if the start is supposed to be grey we have to reverse white and grey array
              // (by injecting the second parameter)
              background={getBackground(index, startsReversed(background))}
              id={`offer-${index}`}
            />
          );

          return acc;
        }, [])}
      </Fragment>
    );
  }
}
